import React, { Component, ErrorInfo, ReactNode } from 'react';
import JoyRide, { Step } from 'react-joyride';
import { IApplicationState, useAppSelector } from '../../../../libs/store/reducers';
import { joyRideGlobalStyles } from './ProductTourConstants';
import Tooltip from './Tooltip';
import { adminTourStepsOnly, tourSteps } from './TourSteps';

interface IProductTourProps {
  startTour: boolean;
}

class ProductTourErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(): { hasError: boolean } {
    return { hasError: true };
  }
  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ProductTour error:', error, info);
  }
  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}

const ProductTour = ({ startTour }: IProductTourProps) => {
  const { userDetails } = useAppSelector(({ user: { userDetails } }: IApplicationState) => ({
    userDetails,
  }));
  let userTourSteps: Step[];
  if (!userDetails?.user_permissions?.add_account) {
    userTourSteps = tourSteps.filter((toursteps) =>
      adminTourStepsOnly.every((steps) => steps !== toursteps.title),
    );
  } else {
    userTourSteps = tourSteps;
  }

  return (
    <ProductTourErrorBoundary>
      <JoyRide
        steps={userTourSteps}
        continuous
        tooltipComponent={Tooltip}
        showProgress
        styles={joyRideGlobalStyles}
        run={startTour}
      />
    </ProductTourErrorBoundary>
  );
};

export default ProductTour;
